import { getWithToken } from './ApiService';

import { PropertiesByCategory } from '../Interface/Response/ProductProperty/List/PropertiesByCategory';
import { PropertiesPerLabel } from '../Interface/Response/Interest/PropertiesPerLabel';
import { PropertiesPerProperty } from '../Interface/Response/Interest/PropertiesPerProperty';

export const getPropertiesByCategory = (): Promise<PropertiesByCategory[]> =>
    getWithToken<PropertiesByCategory[]>(`v1/filter/product-properties/list`);

export const getPropertiesPerLabel = (labels: string[]): Promise<PropertiesPerLabel[]> =>
    getWithToken<PropertiesPerLabel[]>(`v1/filter/product-properties/products/${labels.join()}`);

export const getPropertiesPerProperty = (properties: string[]): Promise<PropertiesPerProperty[]> =>
    getWithToken<PropertiesPerProperty[]>(`v1/filter/product-properties/properties/${properties.join()}`);
